<template>
  <div class="menu-button">
    <slot>
      <img
        :src="icon"
        class="icon"
      >
    </slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MenuButtonComponent',

  props: {
    icon: {
      type: String,
      default: '',
    },
  },
});
</script>

<style lang="scss" scoped>
.menu-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  z-index: 10000;

  @media screen and (min-width: $tablet_breakpoint) {
    width: 48px;
    height: 48px;
  }

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    width: 140px;
    height: 140px;
  }

  @media screen and (max-height: $mobile_height_breakpoint) {
    width: 38px;
    height: 38px;
  }
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    width: 80px;
    height: 80px;
  }
}
</style>
